export const degrees = [
    "AISSCE",
    "AISSE",
    "AWS Certification",
    "BA (Bachelor of Arts)",
    "BA LLB",
    "BAMS",
    "BArch",
    "BBA",
    "BBA LLB",
    "BCA",
    "BCom (Bachelor of Commerce)",
    "BCom LLB",
    "BDS",
    "BDes Fashion Design",
    "BDes Graphic Design",
    "BDes Interior Design",
    "BDes Product Design",
    "BE Chemical",
    "BE Civil",
    "BE Computer Science",
    "BE Electrical",
    "BE Electronics & Communication",
    "BE Mechanical",
    "BEd",
    "BFA (Bachelor of Fine Arts)",
    "BHM",
    "BHMS",
    "BJMC",
    "BLibSc (Bachelor of Library Science)",
    "BPEd",
    "BPharma",
    "BSW (Bachelor of Social Work)",
    "BSc (Bachelor of Science)",
    "BSc Agriculture",
    "BSc LLB",
    "BSc Nursing",
    "BTech Aerospace",
    "BTech Automobile",
    "BTech Biotechnology",
    "BTech Chemical",
    "BTech Civil",
    "BTech Computer Science",
    "BTech Electrical",
    "BTech Electronics & Communication",
    "BTech Information Technology",
    "BTech Mechanical",
    "BTech Mining",
    "BTech Petroleum",
    "BVSc",
    "BVoc in Automobile",
    "BVoc in Banking Operations",
    "BVoc in Fashion Design",
    "BVoc in Healthcare",
    "BVoc in Interior Design",
    "BVoc in Journalism & Communication",
    "BVoc in Retail Management",
    "BVoc in Software Development",
    "BVoc in Tourism Management",
    "BVoc in Web Designing",
    "Bachelor's Degree (Distance)",
    "CA (Chartered Accountant)",
    "CAIIB (Certified Associate of Indian Institute of Bankers)",
    "CFA (Chartered Financial Analyst)",
    "CISCO Certification",
    "CMA (Cost and Management Accountant)",
    "CS (Company Secretary)",
    "Certificate Course (Distance)",
    "Class I",
    "Class II",
    "Class III",
    "Class IV",
    "Class IX",
    "Class V",
    "Class VI",
    "Class VII",
    "Class VIII",
    "Class X",
    "Class XI",
    "Class XII",
    "DBA",
    "DLitt",
    "DM Cardiology",
    "DM Gastroenterology",
    "DM Nephrology",
    "DM Neurology",
    "DPhil",
    "DSc",
    "Diploma (Distance)",
    "Diploma in Agriculture",
    "Diploma in Architecture",
    "Diploma in Automobile Engineering",
    "Diploma in Chemical Engineering",
    "Diploma in Civil Engineering",
    "Diploma in Computer Science",
    "Diploma in Electrical Engineering",
    "Diploma in Electronics & Communication",
    "Diploma in Information Technology",
    "Diploma in Mechanical Engineering",
    "Diploma in Medical Laboratory Technology",
    "Diploma in Pharmacy",
    "Diploma in Textile Technology",
    "EdD",
    "FRM (Financial Risk Manager)",
    "Google Cloud Certification",
    "HSC",
    "ICSE",
    "ISC",
    "ITI - Commercial Art",
    "ITI - Computer Operator",
    "ITI - Diesel Mechanic",
    "ITI - Draughtsman Civil",
    "ITI - Draughtsman Mechanical",
    "ITI - Dress Making",
    "ITI - Electrician",
    "ITI - Electronics",
    "ITI - Fitter",
    "ITI - Foundry Man",
    "ITI - Hair & Skin Care",
    "ITI - Hand Compositor",
    "ITI - Machinist",
    "ITI - Manufacture Footwear",
    "ITI - Motor Driver cum Mechanic",
    "ITI - Pump Operator",
    "ITI - Refrigeration & AC",
    "ITI - Secretarial Practice",
    "ITI - Sheet Metal Worker",
    "ITI - Stenographer",
    "ITI - Tool & Die Maker",
    "ITI - Turner",
    "ITI - Welder",
    "Integrated PhD",
    "Intermediate Certificate",
    "LLB",
    "LLM Constitutional Law",
    "LLM Corporate Law",
    "LLM Criminal Law",
    "LLM Environmental Law",
    "LLM Human Rights Law",
    "LLM Intellectual Property Rights",
    "LLM International Law",
    "LLM Taxation Law",
    "MA (Master of Arts)",
    "MArch Landscape Architecture",
    "MArch Urban Planning",
    "MBA Finance",
    "MBA Healthcare Management",
    "MBA Human Resources",
    "MBA Information Technology",
    "MBA International Business",
    "MBA Marketing",
    "MBA Operations",
    "MBBS",
    "MCA",
    "MCh Cardiothoracic Surgery",
    "MCh Neurosurgery",
    "MCh Pediatric Surgery",
    "MCom (Master of Commerce)",
    "MD Anesthesia",
    "MD Dermatology",
    "MD Emergency Medicine",
    "MD General Medicine",
    "MD Pathology",
    "MD Pediatrics",
    "MD Psychiatry",
    "MD Radiology",
    "MDS Oral Surgery",
    "MDS Orthodontics",
    "MDS Periodontology",
    "MDS Prosthodontics",
    "MDes Communication Design",
    "MDes Industrial Design",
    "ME Civil",
    "ME Computer Science",
    "ME Electrical",
    "ME Electronics & Communication",
    "ME Mechanical",
    "MEd",
    "MFA (Master of Fine Arts)",
    "MHM",
    "MJMC",
    "MLibSc (Master of Library Science)",
    "MOOC Certificate",
    "MPharma Pharmaceutical Chemistry",
    "MPharma Pharmaceutics",
    "MPharma Pharmacology",
    "MS Cardiothoracic Surgery",
    "MS ENT",
    "MS General Surgery",
    "MS Neurosurgery",
    "MS Ophthalmology",
    "MS Orthopedics",
    "MS Plastic Surgery",
    "MSW (Master of Social Work)",
    "MSc (Master of Science)",
    "MSc Agriculture Agronomy",
    "MSc Agriculture Horticulture",
    "MSc Agriculture Plant Pathology",
    "MSc Nursing Community Health",
    "MSc Nursing Medical Surgical",
    "MTech Biotechnology",
    "MTech Chemical",
    "MTech Civil",
    "MTech Computer Science",
    "MTech Electrical",
    "MTech Electronics & Communication",
    "MTech Mechanical",
    "MTech Power Systems",
    "MTech Structural Engineering",
    "MTech Thermal Engineering",
    "MTech VLSI Design",
    "MVSc Animal Medicine",
    "MVSc Animal Surgery",
    "Master's Degree (Distance)",
    "Micro-credential",
    "Microsoft Certification",
    "Nursery",
    "Oracle Certification",
    "PMP (Project Management Professional)",
    "PRINCE2",
    "PUC",
    "PhD",
    "PhD (Distance)",
    "Professional Certificate (Online)",
    "SSC",
    "SSLC",
    "Scrum Master Certification",
    "State Board Certificate"
  ]